import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { goBack } from 'react-router-redux'

import FirstTimeBookingConfirmation from './FirstTimeBookingConfirmation'
import * as fromEntities from '@src/redux/modules/entities'
import * as fromService from '@src/redux/modules/service'

const FirstTimeBookingConfirmationContainer = reduxForm({
  form: 'coupon',
  validate: (values) => {
    const errors = {}
    return errors
  }
})(FirstTimeBookingConfirmation)

const mapStateToProps = (state, ownProps) => {
  const aliadas = fromEntities.getAliadas(state)
  const aliadaId = ownProps.params.aliadaId
  const { service, promoCode } = fromService.getState(state)

  return {
    aliada: aliadas[aliadaId],
    service,
    promoCode
  }
}

const mapDispatchToProps = {
  goBack
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FirstTimeBookingConfirmationContainer)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/FirstTimeBookingConfirmation/FirstTimeBookingConfirmationContainer.js